import { Box, Typography } from "@mui/material";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import AlgoImage from "../../assets/algoExample.png";
import { useNavigate, useParams } from "react-router-dom";
import { useRecoilState } from "recoil";
import { selectedAlgoState } from "../../recoil";
import { ISelectOption } from "@types";
import { t } from "i18next";
import Scatter2DChart from "./Scatter2DChart";
import PreClassChart from "./PreClassChart";
import { PreClassStep } from "@types";
import { useEffect } from "react";

interface AlgoSecondStepProps extends PreClassStep {
  projectData: any;
}

export default function AlgoSecondStep({
  setCurrentStep,
  projectData,
}: AlgoSecondStepProps) {
  const [selectedAlgo, setSelectedAlgo] = useRecoilState(selectedAlgoState);
  const algoList = [
    { id: "bd31fe2a-4c6a-4919-bebb-47795f578080", name: "A 알고리즘" },
    { id: "b8e0312e-2ba7-41bc-b4f2-76fef881dd0e", name: "B 알고리즘" },
    { id: "e7eb3350-efee-41db-96e8-bf91ea2a28b4", name: "C 알고리즘" },
    { id: "28c20f9b-1edd-4948-b275-0315d417edb6", name: "D 알고리즘" },
  ];
  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3,
      slidesToSlide: 1,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2,
      slidesToSlide: 1,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
      slidesToSlide: 1,
    },
  };

  const handleSelectAlgo = (algoItem: ISelectOption) => {
    // navigate(`/project/${id}/analysis/step=3/${algoItem.id}`);
    setSelectedAlgo((prev) => ({
      ...prev,
      algoId: algoItem.id,
      algoName: algoItem.name,
    }));
    setCurrentStep(3);
  };

  return (
    <Box
      sx={{
        height: "400px",
        "& .react-multi-carousel-list.container": {
          alignItems: "flex-start !important",
        },
        "& .react-multiple-carousel__arrow": {
          top: "30% !important",
          transform: "translateY(-30%)",
        },
        "& .react-multiple-carousel__arrow--right": {
          right: 0,
        },
        "& .react-multiple-carousel__arrow--left": {
          left: 0,
        },
      }}
    >
      <Typography>{selectedAlgo.classCount}개의 클래스</Typography>
      <Box sx={{ height: "fit-content" }}>
        <Carousel
          additionalTransfrom={0}
          arrows
          autoPlaySpeed={3000}
          centerMode={false}
          className=""
          containerClass="container"
          dotListClass=""
          draggable
          focusOnSelect={false}
          keyBoardControl
          minimumTouchDrag={80}
          partialVisible
          pauseOnHover
          renderArrowsWhenDisabled={false}
          renderButtonGroupOutside={false}
          renderDotsOutside={false}
          responsive={responsive}
          rewind={false}
          rewindWithAnimation={false}
          rtl={false}
          shouldResetAutoplay
          showDots={false}
          sliderClass=""
          slidesToSlide={1}
          swipeable
        >
          {algoList.map((algoItem, index) => (
            <Box sx={{ width: "300px" }}>
              <Typography>{algoItem.name}</Typography>
              <PreClassChart
                algoItem={algoItem}
                images={projectData.images}
                classList={selectedAlgo.labels || []}
                setCurrentStep={setCurrentStep}
              />
            </Box>
          ))}
        </Carousel>
      </Box>
    </Box>
  );
}
